import React from 'react'
import './CallToAction.scss'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';

const CallToAction = (props) => {
    const navigate = useNavigate();

    const handleHistoryClick = () => {
        navigate('/product/history');
    };

    return (
        <div className="colorlib-cta">
            {props.image && (
                <img src={props.image} alt={props.imageDesc} />
            )}
            <div className="call-to-action text-center">
                <h2>{props.title}</h2>
                <Button variant="primary" onClick={handleHistoryClick}>
                    See what used to be
                </Button>
            </div>
        </div>
    )
}

export default CallToAction;
